import React from "react";

import Contract from "./Contract.jsx";

import { contractSort } from "../../../util/sort.js";

export default function GeneralInfoRight({ contracts }) {
  return (
    <div className="col-sm-9">
      <div className="panel panel-info">
        <div className="panel-heading">
          Contract(s):<span className="text-right"></span>
        </div>
        <div className="panel-body">
          {contracts.sort(contractSort).map((contract) => (
            <Contract key={contract.chScnXrefSeq} contract={contract} />
          ))}
          <div className="row text-center">
            <a href="http://www.sewp.nasa.gov/contract_info.shtml">Download SOW and Contract Clauses</a>
          </div>
        </div>
      </div>
    </div>
  );
}
